export default "__VITE_ASSET__BLMFZ77v__"